import {
  Box,
  Button,
  CardActionArea,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'

import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import Modals from '../../Components/Modals'

import CategorizationTable from '../../Components/CategorizationTable'
import DirectionSnackbar from '../../Components/Snackbar'
import AddRulesModal from './Rules/AddRulesModal'
import AutoCategorizeModal from './AutoCategorizeModal'
import InternalTransfersModal from './InternalTransfersModal'
import { makeGetRequest } from 'utils/api'
import { makeDeleteRequest } from 'utils/api'
const Categorisation = () => {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const addRulesRef = useRef(null)
  const autoCatRef = useRef(null)
  const internalTransfersRef = useRef(null)
  const [categories, setCategories] = useState([])
  // const [categories, setCategories] = useState([]);

  const [updateTable, setUpdateTable] = useState(false)
  const [loading, setLoading] = React.useState(false)
  const [operations, setOperations] = React.useState({})
  // const [ modules, setModules ] = React.useState( {} );
  // const [ classifications, setClassifications ] = React.useState( {} );
  const [emptyCatOp, setEmptyCatOp] = useState({})
  const [emptyLoad, setEmptyLoad] = useState(null)
  const [voirToutBtn, setVoirToutBtn] = useState(false)
  const [automation, setAutomation] = useState(0)
  const [openSnack, setOpenSnak] = useState({
    message: '',
    color: '',
    open: false,
  })

  useEffect(() => {
    // fetchClassifications()
    // fetchModules();

    fetchCategory()
    fetchOperations()
    fetchEmptyOperations()
    fetchAutoMation()
  }, [updateTable])

  useEffect(() => {
    fetchEmptyOperations()
    fetchAutoMation()
  }, [])
  const fetchOperations = async (url = '') => {
    setLoading(true)
    let response = null

    response = await makeGetRequest('/api/Finance/Operationsfi' + url, {}, true)
    setOperations({ ...response.data })

    // if (response.status === 200) {
    //   const filterData = response.data.results.filter((v) => {
    //     return v.SousCategorie.length === 0;
    //   });
    //   setEmptyCatOp([...filterData]);
    // }
    setLoading(false)
  }

  const fetchEmptyOperations = async () => {
    const response = await makeGetRequest(`/api/Finance/empty/operationsfi`, {}, true)
    if (response.status === 200) {
      setEmptyCatOp({ ...response.data })
    }
  }
  const fetchAutoMation = async () => {
    const response = await makeGetRequest(`/api/Finance/automation`, {}, true)
    if (response.status === 200) {
      setAutomation(response.data)
    }
  }

  const loadEmptyOperations = async (limit) => {
    const response = await makeGetRequest(
      `/api/Finance/empty/operationsfi/?limit=${limit}`,
      {},
      true,
    )
    if (response.status === 200) {
      setEmptyCatOp({ ...response.data })
      setOperations({ ...response.data })
    }
  }
  const updateLoading = async (e) => {
    setEmptyLoad(true)
    fetchEmptyOperations()
    fetchAutoMation()
    // setEmptyCatOp([...filterData]);
  }
  const fetchCategory = async () => {
    const { data } = await makeGetRequest('/api/Finance/Categoriesfi', {}, true)
    setCategories([...data])
  }

  const deleteCat = async (selected) => {
    selected.forEach(async function (id) {
      await makeDeleteRequest('/api/Finance/del/category/' + id, {}, true)
      fetchCategory()
    })
    setOpenSnak({
      open: true,
      color: 'info',
      message: t('finance.categorisation.categoryDeleted'),
    })
    setTimeout(() => {
      setOpenSnak({
        open: false,
        color: 'success',
        message: '',
      })
    }, 2000)
  }

  const handleChange = (e) => {
    setUpdateTable(!updateTable)
  }

  const filterEmptyCategories = (e) => {
    setVoirToutBtn(true)
    setEmptyLoad(true)
    setOperations({ ...emptyCatOp })
    fetchCategory()
  }
  const seeEveryOperation = (e) => {
    fetchOperations()
    setVoirToutBtn(false)
    setEmptyLoad(false)
  }
  return (
    <Container maxWidth="xl" className="no-drag">
      {openSnack.open && <DirectionSnackbar message={openSnack.message} color={openSnack.color} />}
      <Box
        sx={{ flexGrow: 1, backgroundColor: theme.palette.shellBar }}
        className="rounded mt-3 no-drag"
        p={2}
      >
        <Grid container spacing={3} align="center">
          <Grid item xs={4}>
            <Typography color="white" variant={isMobile ? 'h6' : 'h3'} component="div" gutterBottom>
              {parseFloat(automation).toFixed(2)} %
            </Typography>
            <Typography color="white" variant="body2" gutterBottom>
              {t('finance.categorisation.automationRate')}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <CardActionArea onClick={filterEmptyCategories}>
              <Typography
                color="white"
                variant={isMobile ? 'h6' : 'h3'}
                component="div"
                gutterBottom
              >
                {emptyCatOp && emptyCatOp.count}
              </Typography>

              <Typography color="white" variant="body2" gutterBottom>
                {t('finance.categorisation.toCategorizeCount')}
              </Typography>
            </CardActionArea>
          </Grid>
          <Grid item xs={4}>
            <Typography color="white" variant={isMobile ? 'h6' : 'h3'} component="div" gutterBottom>
              {categories && categories.length}
            </Typography>
            <Typography color="white" variant="body2" gutterBottom>
              {t('finance.categorisation.categoriesCount')}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'end' }} py={3}>
        <Box display="flex">
          {voirToutBtn && (
            <Button
              sx={{
                marginLeft: '5px',
                color: 'white',
                '&:hover': { color: 'black', backgroundColor: 'white' },
              }}
              onClick={seeEveryOperation}
            >
              {t('finance.categorisation.seeAll')}
            </Button>
          )}
          <Button
            sx={{
              marginLeft: '5px',
              color: 'white',
              '&:hover': { color: 'black', backgroundColor: 'white' },
            }}
            onClick={() => autoCatRef.current.handleClickOpen()}
          >
            {t('finance.categorisation.autoCat.title', { defaultValue: 'Catégoriser tout' })}
          </Button>
          <Modals
            label={t('finance.categorisation.manageCategories')}
            handleChange={handleChange}
            categories={categories}
            deleteCat={deleteCat}
          />
          <Button
            sx={{
              marginLeft: '5px',
              color: 'white',
              '&:hover': { color: 'black', backgroundColor: 'white' },
            }}
            onClick={() => addRulesRef.current.handleClickOpen()}
          >
            {t('finance.categorisation.manageRules')}
          </Button>
          <Button
            sx={{
              marginLeft: '5px',
              color: 'white',
              '&:hover': { color: 'black', backgroundColor: 'white' },
            }}
            onClick={() => internalTransfersRef.current.handleClickOpen()}
          >
            {t('finance.internalTransfers.title', { defaultValue: 'Virements internes' })}
          </Button>
        </Box>
      </Box>

      <CategorizationTable
        loading={loading}
        emptyLoad={emptyLoad}
        updateLoading={updateLoading}
        operations={operations}
        categories={categories}
        // modules={modules}
        // classification={classifications}
        fetchOperations={fetchOperations}
        fetchEmptyOperations={loadEmptyOperations}
      />

      <AddRulesModal
        ref={addRulesRef}
        handleChange={handleChange}
        // categories={categories}
        // deleteCat={deleteCat}
      />

      <AutoCategorizeModal
        ref={autoCatRef}
        showAccountSelector
        onComplete={() => {
          handleChange()
          fetchEmptyOperations()
          fetchAutoMation()
        }}
      />

      <InternalTransfersModal
        ref={internalTransfersRef}
        onComplete={() => {
          handleChange()
          fetchEmptyOperations()
        }}
      />
    </Container>
  )
}

export default Categorisation
